import { useMemo } from 'react';

import type {
  ThirdPartyContactFields,
  ThirdPartyContactWithStatus,
} from './types';

type ContactStatus = 'active' | 'pending' | 'revoked';

export const getContactStatus = (
  isRevoked: boolean,
  lastSeen: string | null | undefined
): ContactStatus => {
  if (isRevoked) {
    return 'revoked';
  }
  if (lastSeen) {
    return 'active';
  }

  return 'pending';
};

export const mapContactWithStatus = (
  contact: ThirdPartyContactFields
): ThirdPartyContactWithStatus => {
  const lastLogin = contact.user?.LastSeen ?? null;
  const status = getContactStatus(contact.IsRevoked, lastLogin);

  return {
    ...contact,
    lastLogin,
    status,
  };
};

export const useContactsWithStatus = (
  contacts: ThirdPartyContactFields[]
): ThirdPartyContactWithStatus[] => {
  return useMemo(() => contacts.map(mapContactWithStatus), [contacts]);
};
